<!-- Creato per il bando ISMEA che si terrà il 18 dicembre 2024 -->

<!-- TODO FUTURA: se si farà nuovamente il bando ISMEA, rivedere per utilizzare il componente corretto come in SimulazioneIsiINAIL -->

<template>
<div>
  <div style="background-color: white !important">

    <v-alert v-if="alertType" :type="alertType" :value="true" outlined>
      <span v-html="message"></span>
    </v-alert>

    <v-banner v-if="isCliente" style="color:white; font-size:18px; font-weight:600;" :color="scdOrange" sticky slot="icon">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon class="mr-9" icon="mdi-alert-outline" color="white" size="40">mdi-alert-outline</v-icon>
          <div class="mr-9" style="line-height:1.3;">
            <div class="mb-2">Hai terminato le simulazioni disponibili !</div>
            <div>Per continuare ad allenarti, acquista una ricarica: con pochi click, le nuove simulazioni saranno immediatamente a tua disposizione.</div>
          </div>
        </div>
        <v-btn @click="apriDialogAcquistoRicariche()" class="mr-7" style="color:white; border-radius:0;" depressed color="green">Ricarica le simulazioni</v-btn>
      </div>
    </v-banner>

    <v-banner v-else-if="isCliccatore" style="color:white; font-size:18px; font-weight:600;" :color="scdOrange" sticky slot="icon">
      <div class="d-flex align-center">
        <v-icon class="mr-9" icon="mdi-alert-outline" color="white" size="40">mdi-alert-outline</v-icon>
        <div class="mr-9">
          <div>Hai terminato le simulazioni disponibili: contatta il tuo amministratore per richiederne altre e continuare ad allenarti.</div>
        </div>
      </div>
    </v-banner>

    <v-banner v-else-if="isProvaGratuita" style="color:white; font-size:18px; font-weight:600;" :color="scdOrange" sticky slot="icon">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon class="mr-9" icon="mdi-alert-outline" color="white" size="40">mdi-alert-outline</v-icon>
          <div class="mr-9" style="lineheight:1.2;">
            <div class="mb-2">Hai terminato le simulazioni disponibili !</div>
            <div>Acquista uno dei nostri pacchetti per iniziare ad allenarti sul serio, ti bastano pochi click.</div>
          </div>
        </div>
        <v-btn @click="apriPaginaPacchetti()" class="mr-7" style="color:white; border-radius:0;" depressed color="green">Acquista un pacchetto</v-btn>
      </div>
    </v-banner>

    <header class="mt-0">
      <!-- <h1>INAIL - Istituto Nazionale per l'Assicurazione contro gli Infortuni sul Lavoro</h1> -->
      <!-- <a id="logo-inail" href="https://bandoisi.inailcloud.it/html/dummy.html#" title="torna alla homepage INAIL"> -->

      <!-- <div :style="`background-color:${scdOrange}; height:400px;`">

      </div> -->

      <div class="d-flex justify-space-between">
        <a id="logo-inail" href="#">
          <img src="https://app.simulatoreclickday.it/img/logoIsmea.png">
        </a>

        <!-- <v-btn data-tour-step-simulazioni="11" depressed :color="scdOrange" class="_semi_bold white--text px-12 btn dati-personali" @click="computedClienteClickdayIt ? popUpDatiCliccatore() : showDatiCliccatore()" style="text-transform:none; letter-spacing:0.5px; height:50px;">
          Apri Finestra Dati Personali
        </v-btn> -->

        <div class="mt-4">
          <input
	          @click="computedClienteClickdayIt ? popUpDatiCliccatore() : showDatiCliccatore()"
	          type="button"
	          value="Apri Finestra Dati Personali"
	          class="btn dati-personali"
          >
        </div>

        <div class="width: 212px">
          <!--<input @click="isSimulazioneGuidata || simulazioniTerminate ? goBack() : abbandona()" :disabled="isLeftingSimulazione" type="button" :value="`${ simulazioniTerminate ? 'Torna alla Home' : 'Abbandona simulazione'}`" class="btn abbandona simulazione-step-8">-->
        </div>
      </div>
      
    </header>

    <div class="main">
      <div style="padding-left:5px" class="simulazione-step-2">

        <div class="mb-3" style="font-size: 110%;" v-if="false">
          <strong>
            <div class="d-flex justify-center align-center" style="color:#002e5f; height: 100%;">
              La simulazione comincia alle ore <span class="px-1 simulazione-step-1">{{ orarioSimulazione }}.</span> Basati sull'orario che trovi sul sito <a class="ml-1" href="https://time.is/clock" target="_blank">time.is</a>
            </div>
            <div class="d-flex justify-center align-center" style="color:#002e5f; height: 100%;">
              ⚠️ In questa schermata (la n° {{fintoStep}}) clicca sul pulsante "AVANTI" solo dopo l'orario di inizio
            </div>
            <div class="d-flex justify-center align-center" style="color:#002e5f; height: 100%;">
              Per maggiori dettagli leggi il consiglio n° 2 che trovi nella pagina <a class="ml-1" href="/home#/gaming-consigli" target="_blank">Consigli</a>
            </div>
          </strong>
        </div>

        <v-card outlined class="pa-6" style="background-color: #EFEFEF; border:0px;">
          <h2 style="line-height: 1.2; font-weight: 600;">Fondo Innovazione 2024</h2>

          <v-stepper v-model="fintoStep" class="mb-6" style="background-color: transparent !important; box-shadow: none !important; border: none !important;">
            <!-- Step Headers -->
            <v-stepper-header>
              <v-stepper-step step="1" color="#36BEA2"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" color="#36BEA2"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" color="#36BEA2"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4" color="#36BEA2"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="5" color="#36BEA2"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="6" color="#36BEA2"></v-stepper-step>
            </v-stepper-header>
          </v-stepper>

          <template v-if="fintoStep == 1">
            <div style="height: 200px">
              <v-skeleton-loader boilerplate type="text" width="360" />
              <br>
              <v-skeleton-loader boilerplate type="text" width="350" />
              <v-skeleton-loader boilerplate type="text" />
              <v-skeleton-loader boilerplate type="text" />
            </div>
          </template>
          
          <!-- Lo step 2 si deve sempre saltare (è così sulla pagina ufficiale ISMEA) -->
          <!-- <template v-else-if="fintoStep == 2">
            <div style="height: 750px"></div>
          </template> -->

          <template v-else-if="fintoStep == 3">
            <div style="height: 2650px">
              <v-skeleton-loader boilerplate type="text" width="360" /><br>
              <v-skeleton-loader boilerplate type="text" width="360" /><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
            </div>
          </template>

          <template v-else-if="fintoStep == 4">
            <div style="height: 2650px">
              <v-skeleton-loader boilerplate type="text" width="360" /><br>
              <v-skeleton-loader boilerplate type="text" width="360" /><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br>
              <v-skeleton-loader boilerplate type="text"/><br><br>
            </div>
          </template>

          <template v-else-if="fintoStep == 5">
            <!-- Nello step 5 ci sono informazioni statiche (ed è il primo step visibile quando si entra in Simulazione) -->
            <v-row>
              <v-col cols="12">
                <h4>Passo del modulo: Investimenti</h4>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>L’impresa beneficiaria si classifica come</v-list-item-title>
                    <v-list-item-subtitle>Agricoltura</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Impresa Giovane?</v-list-item-title>
                    <v-list-item-subtitle>No</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Categoria investimento</v-list-item-title>
                    <v-list-item-subtitle>5.1.a</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Percentuale attività di produzione primaria</v-list-item-title>
                    <v-list-item-subtitle>100%</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Importo investimento dedicato alla produzione primaria</v-list-item-title>
                    <v-list-item-subtitle>10</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Codice ATECO</v-list-item-title>
                    <v-list-item-subtitle>01.11.10 - Coltivazione di cereali (escluso il riso)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Data di iscrizione in CCIAA</v-list-item-title>
                    <v-list-item-subtitle>01/03/2018</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Descrizione</v-list-item-title>
                    <v-list-item-subtitle>
                      Acquisto di macchinari agricoli per migliorare la produzione primaria di cereali, con particolare attenzione alla sostenibilità e all’efficienza energetica.
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Preventivi Allegati</v-list-item-title>
                    <v-list-item-subtitle>
                      <ul>
                        <li>Preventivo 1: <a href="#">Preventivo_1_Allegato.pdf</a></li>
                        <li>Preventivo 2: <a href="#">Preventivo_2_Allegato.pdf</a></li>
                        <li>Preventivo 3: <a href="#">Preventivo_3_Allegato.pdf</a></li>
                      </ul>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Totale investimenti dichiarato</v-list-item-title>
                    <v-list-item-subtitle>10,00 €</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Totale contributo concedibile</v-list-item-title>
                    <v-list-item-subtitle>0,00 €</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </template>

          <template v-else-if="fintoStep == 6">
            <div>
              <h4 class="mb-4 font-weight-bold">Passo del modulo: Allegati</h4>
        
              <!-- Allegati -->
              <v-row>
                <v-col cols="12">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Visura centrale rischi*</v-list-item-title>
                      <v-list-item-subtitle>
                        <a href="#">Preventivo_1_Allegato.pdf</a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Modulo di autocertificazione sull’assenza di cause di esclusione*</v-list-item-title>
                      <v-list-item-subtitle>
                        <a href="#">Preventivo_3_Allegato.pdf</a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Modulo della domanda sottoscritto (una volta completata la compilazione della domanda, il modulo può essere scaricato cliccando in alto a destra su ‘Scarica PDF’)
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <a href="#">INN24_01628_P_signed.pdf</a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
  
              <!-- Dichiarazione -->
              <v-row class="mt-6">
                <v-col cols="12">
                  <v-checkbox
                    label="essere a conoscenza che l’indirizzo PEC indicato nell’anagrafica della presente domanda e verificato a mezzo OTP in questa pagina sarà utilizzato da ISMEA per TUTTE le comunicazioni procedimentali e che rimane a totale rischio dell’impresa il non corretto funzionamento o l’errata indicazione della casella di posta certificata."
                    v-model="sempreTrue"
                    readonly
                  ></v-checkbox>
                </v-col>
              </v-row>
  
              <!-- PEC e OTP -->
              <v-row class="mt-4">
                <v-col cols="12" md="6">
                  <v-text-field
                    label="PEC*"
                    v-model="pecIsmea"
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn style="background-color: #343B4D; color: white">Invia OTP</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="OTP ricevuto*"
                    value="yckswY"
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn style="background-color: #343B4D; color: white">Verifica OTP</v-btn>
                </v-col>
              </v-row>
            </div>

            <v-form ref="formEseguiSimulazione">
              <input type="hidden" name="_token" :value="csrf">
              
              <!-- Mostra comunque la prima parte della pagina se la domanda non è ancora partita -->
              <fieldset v-if="status == 'started'" id="form-fieldset">
                <div style="display:inline-block; width: 100%" class="simulazione-step-3 simulazione-step-5">
                  <div
                    :id="sim.id"
                    v-for="(sim, index) in datiSimulazione.simulazione"
                    :key="sim.id"
                    :class="`${sim.rispostaNonCorretta ? 'errore ' : ''} form-elem xs-12 md-6`"
                  >

                    <!-- Nota: l'oggetto "sim" è la domanda corrente, non l'intera simulazione -->
                    <label v-if="sim.tipo != 'checkbox'
                      && sim.tipo != 'checkbox_bloccante'
                      && sim.tipo != 'checkbox_reverse'
                      && sim.tipo != 'summary'
                      && sim.show"
                    >
                      {{ sim.domanda }}: *
                    </label>

                    <!-- La risposta potrebbe avere la forma {AA}BB{CC} in cui AA e CC sono solo scritte mostrate all'utente, mentre BB è la parte che deve inserire -->
                    <!-- Di seguito vi è un v-for in cui vengono gestiti i tipi che potrebbero avere campi statici. Gli altri tipi (radio, checkbox, ecc..) sono gestiti in seguito -->
                    <v-row no-gutters style="margin-top: 8px;" v-if="['validate_text', 'unpastable', 'monochar', 'text', 'select'].includes(sim.tipo)">
                      <div class="d-flex">
                        <div style="display:inline" v-for="(parteRisposta, idx) in ottieniPartiStringa(risposteCorrette[sim.id])" :key="sim.id+'_'+idx">

                          <!-- Tipo 'validate_text': -->
                          <template v-if="sim.tipo == 'validate_text' && sim.show">
                            <span :ref="sim.id" v-if="parteRisposta.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">{{ parteRisposta.contenuto }}</span>
                            <!-- v-model="risposteUtente[sim.id]" -->
                            <input
                              v-else
                              :ref="sim.id"
                              type="text"
                              :name="`risposte[${index}]`"
                              class="form-control"
                              autocomplete="off"
                              tabindex="1"
                              style="width: 150px;"
                              @input="risposteUtente[sim.id] = $event.target.value"
                            >
                            <!-- Nota: il @input sopra riempie comunque la risposta utente che viene adoperata per un controllo sulla lunghezza dell'input -->
                            <!-- Il bottone di Convalida viene gestito fuori dal v-for, quindi in seguito -->
                          </template>

                          <!-- Tipo 'unpastable' -->
                          <template v-else-if="sim.tipo == 'unpastable' && sim.show">
                            <span :ref="sim.id" v-if="parteRisposta.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">{{ parteRisposta.contenuto }}</span>
                            <!-- v-model="risposteUtente[sim.id]" -->
                            <input
                              v-else
                              :ref="sim.id"
                              type="text"
                              :name="`risposte[${index}]`"
                              class="form-control"
                              autocomplete="off"
                              tabindex="1"
                              @paste.prevent
                            >
                          </template>
                          <!-- =================== -->

                          <!-- Riportato anche qui il tipo 'monochar' che era presente nel VIM (ma modificato) -->
                          <template v-else-if="sim.tipo == 'monochar' && sim.show">
                            <div style="display: inline-flex; gap: 4px;">

                            <!-- <div class="form-row"> -->
                              <span :ref="sim.id" v-if="parteRisposta.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">{{ parteRisposta.contenuto }}</span>
                              <!-- <div v-else style="display:inline" v-for="(char, index) of sim.risposte[0]" :key="index"> -->
                              <div v-else style="display:inline" v-for="(char, index) of parteRisposta.contenuto" :key="index">
                                <!-- <div class="col-auto"> -->
                                  <!-- Provato a gestire senza funzione handleMonochar(..) con il solo ref -->
                                  <!-- @input="handleMonochar(index, $event.data, sim)" -->
                                  <input
                                    :ref="sim.id"
                                    type="text"
                                    minlength="1"
                                    maxlength="1"
                                    size="1"
                                    pattern="[A-Za-z0-9]{1,1}$"
                                    style="text-align: center; font-size: 18px; width: 44px;"
                                  >
                                <!-- </div> -->
                              </div>
                            <!-- </div> -->

                            </div>
                          </template>
                          <!-- ============================ -->

                          <!-- Tipo 'text' -->
                          <template v-else-if="sim.tipo == 'text' && sim.show">
                            <span :ref="sim.id" v-if="parteRisposta.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">{{ parteRisposta.contenuto }}</span>
                            <!-- v-model="risposteUtente[sim.id]" -->
                            <input
                              v-else
                              :ref="sim.id"
                              type="text"
                              :name="`risposte[${index}]`"
                              class="form-control"
                              autocomplete="off"
                              tabindex="1"
                            >
                          </template>
                          <!-- ============================ -->

                          <!-- Tipo 'reverse' -->
                          <template v-else-if="sim.tipo == 'reverse' && sim.show">
                            <span :ref="sim.id" v-if="parteRisposta.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">{{ parteRisposta.contenuto }}</span>
                            <!-- v-model="risposteUtente[sim.id]" -->
                            <input
                              v-else
                              :ref="sim.id"
                              type="text"
                              :name="`risposte[${index}]`"
                              class="form-control"
                              autocomplete="off"
                              tabindex="1"
                            >
                          </template>
                          <!-- ============================ -->

                          <!-- Tipo 'select' -->
                          <template v-else-if="sim.tipo == 'select' && sim.show">
                            <span :ref="sim.id" v-if="parteRisposta.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">{{ parteRisposta.contenuto }}</span>
                            <!-- v-model="risposteUtente[sim.id]" -->
                            <select
                              v-else
                              :ref="sim.id"
                              :name="`${sim.id}`"
                              style="-webkit-appearance:menulist; -moz-appearance:menulist; appearance:menulist;"
                              tabindex="1"
                            >
                              <!-- La prima option serve -->
                              <option value="" disabled selected hidden></option>
                              <!-- Per la risposta corretta mostro la parte senza graffe, per le altre risposte invece mostro tutto -->
                              <option v-for="(risposta, i) in sim.risposte" :key="i" :value="risposta == risposteCorrette[sim.id] ? parteRisposta.contenuto : risposta">{{ risposta == risposteCorrette[sim.id] ? parteRisposta.contenuto : risposta }}</option>
                            </select>
                          </template>
                          <!-- ============================ -->

                        </div>

                        <v-btn v-if="sim.tipo == 'validate_text' && sim.show"
                          @click="verificaValidateText(index)"
                          :style="(sim.rispostaValidata ? 'background-color: #4A4846;' : 'background-color: #4A4846;') + ' color: white; border-radius: 0; margin-left: 50px;'">
                            Convalida
                        </v-btn>
                      </div>
                    </v-row>
                    <!-- ============================ -->

                    <!-- Nuovo tipo 'INN24_select_PC' -->
                    <!-- Sostituito da una qualunque select con campi statici -->
                    <!-- <template v-else-if="sim.tipo == 'INN24_select_PC' && sim.show">
                      <div>
                        <div class="d-flex align-center">
                          <span>INN24_</span>
                          <select
                            v-model="risposteUtente[sim.id]"
                            :name="`${sim.id}`"
                            style="width:100px; -webkit-appearance:menulist; -moz-appearance:menulist; appearance:menulist;"
                            tabindex="1"
                          >
                            <option value="" disabled selected hidden>Scegli una risposta</option>
                            <option v-for="(risposta, i) in sim.risposte" :key="i" :value="risposta">{{ risposta }}</option>
                          </select>
                          <span>_PC</span>
                        </div>
                      </div>
                    </template> -->
                    <!-- ============================ -->

                    <!-- Nuovi tipi: 'unpastable_split_1_2_3' | unpastable_split_1_2 | unpastable_split_2_3 | unpastable_split_1_3 | unpastable_split_1 | unpastable_split_2 | unpastable_split_3 -->
                    <!-- Sostituito da un qualunque 'unpastable' -->
                    <!-- <template v-if="sim.tipo.startsWith('unpastable_split_') && sim.show">
                      <v-row no-gutters class="d-flex" style="margin-top: 8px;">
                        <div class="d-flex">
                          <input
                            type="text"
                            style="width:100px;"
                            v-model="risposteUtenteSplitted[sim.id]['split_1']"
                            :name="`risposte[${index}]`"
                            class="form-control"
                            autocomplete="off"
                            tabindex="1"
                            :readonly="!sim.tipo.includes('_1')"
                            @paste.prevent
                          >
                          <span class="mx-1" style="font-size: 33px; line-height: 1;">_</span>
                          <input
                            type="text"
                            style="width:100px;"
                            v-model="risposteUtenteSplitted[sim.id]['split_2']"
                            :name="`risposte[${index}]`"
                            class="form-control"
                            autocomplete="off"
                            tabindex="1"
                            :readonly="!sim.tipo.includes('_2')"
                            @paste.prevent
                          >
                          <span class="mx-1" style="font-size: 33px; line-height: 1;">_</span>
                          <input
                            type="text"
                            style="width:100px;"
                            v-model="risposteUtenteSplitted[sim.id]['split_3']"
                            :name="`risposte[${index}]`"
                            class="form-control"
                            autocomplete="off"
                            tabindex="1"
                            :readonly="!sim.tipo.includes('_3')"
                            @paste.prevent
                          >
                        </div>
                      </v-row>
                    </template> -->
                    <!-- ============================ -->
                    
                    <template v-else-if="sim.tipo == 'radio' && sim.show">
                      <v-row no-gutters>
                        <template v-for="(risposta, index) in sim.risposte">
                          <v-col cols="12">
                            <div>
                              <input
                                :ref="sim.id"
                                type="radio"
                                :id="`${sim.id}_${index}`"
                                :value="risposta"
                                v-model="risposteUtente[sim.id]"
                                :name="`${sim.id}`"
                              >
                              <label class="radio-label" :for="`${sim.id}_${index}`">{{ risposta }}</label>
                            </div>
                          </v-col>
                        </template>
                      </v-row>
                    </template>
                    
                    <template v-else-if="sim.tipo == 'radio3' && sim.show">
                      <v-row no-gutters>
                        <template v-for="(risposta, index) in sim.risposte">
                          <v-col cols="4">
                            <div>
                              <input
                                :ref="sim.id"
                                type="radio"
                                :id="`${sim.id}_${index}`"
                                :value="risposta"
                                v-model="risposteUtente[sim.id]"
                                :name="`${sim.id}`"
                              >
                              <label class="radio-label" :for="`${sim.id}_${index}`">{{ risposta }}</label>
                            </div>
                          </v-col>
                        </template>
                      </v-row>
                    </template>

                    <input
                      v-else-if="sim.tipo == 'data' && sim.show"
                      :ref="sim.id"
                      type="date"
                      v-model="risposteUtente[sim.id]"
                      :name="`${sim.id}`"
                      class="form-control"
                      autocomplete="off"
                      tabindex="1"
                    >

                    <template v-else-if="(
                      sim.tipo == 'checkbox'
                      || sim.tipo == 'checkbox_bloccante'
                      || sim.tipo == 'checkbox_reverse'
                      ) && sim.show"
                    >
                      <input
                        :ref="sim.id"
                        type="checkbox"
                        :id="`${sim.id}_${index}`"
                        v-model="risposteUtente[sim.id]"
                        :name="`${sim.id}`"
                      >
                      <label :for="`${sim.id}_${index}`">{{ `${sim.domanda} *` }}</label>
                    <!--  ho usato index al posto di sim.id perchè per qualche motivo non funzionava -->
                    </template>
                    
                    <div v-else-if="sim.tipo == 'summary' && sim.show">
                      <div style="font-size: 18px; margin-bottom: 10px">Riepilogo dati inseriti</div>
                      <div class="mb-3">
                        <div
                          v-for="item in summaryData"
                          class="mb-3"
                        >
                            <span class="font-weight-bold mr-2">
                              {{ item.domanda}}:
                            </span>
                          <span>
                            {{
                              typeof item.rispostaUtente == 'boolean'
                                ? (item.rispostaUtente == true ? 'Si' : 'No')
                                : item.rispostaUtente
                            }}
                          </span>
                        </div>
                      </div>
                      
                      <div class="font-weight-bold mt-6">
                        Informativa: I dati inseriti potrebbero essere oggetto di verifica durante la lavorazione della domanda.
                      </div>
                      
                      <div class="mb-6">
                        <input
                          type="checkbox"
                          :id="`${sim.id}_${index}`"
                          v-model="risposteUtente[sim.id]"
                          :name="`${sim.id}`"
                        >
                        <label :for="`${sim.id}_${index}`">Accetto *</label>
                      </div>
                      
                      <div>Cliccare sul pulsante <span class="font-weight-bold">Indietro</span> per modificare i dati inseriti</div>
                      <div>Cliccare sul pulsante <span class="font-weight-bold">{{ tastoContinuaVisibile ? 'Continua' : 'Invia'}}</span> per confermare i dati inseriti ed inviare la domanda</div>
                    </div>
                    
                    <!--<div v-if="">-->
                    <!--  ERRORE: Campo obbligatorio-->
                    <!--</div>-->
                  </div>
                </div>
              </fieldset>
              
              <!-- <div class="d-flex justify-space-between mt-10">
                <div class="d-flex justify-start"></div>
                <div class="d-flex justify-end">
                  <input
                    @click="vaiAPagina(1)"
                    type="button"
                    style="background-color: #33A2F5"
                    value="Indietro"
                    class="btn simulazione-step-8 mr-5"
                  >

                  <input
                    v-if="status == 'started'"
                    type="button"
                    @click="mostraFormConfermaInvioISMEA()"
                    :disabled="eseguitaSimulazioneConGuida || simulazioniTerminate || checkboxesBloccantiAttive"
                    style="background-color: #36BEA2"
                    value="Convalida"
                    class="btn btn-green simulazione-step-6"
                    tabindex="2"
                  >
                  <input
                    v-else
                    type="button"
                    style="background-color: #FFF4D4; color: #CFBA72; border: 1px solid #CFBA72;"
                    value="Salva come bozza"
                    title="Salva come bozza"
                    class="btn mr-5"
                    tabindex="3"
                  >
                </div>
              </div> -->
            </v-form>
          </template>

          <v-row justify="end" class="mt-4 px-6">
            <!-- 
              Step 1/6: Esci
              Step 2/6: Vai indietro
              Step 1/6: Salva come bozza
              Step 1/5: Vai avanti
              Step 6 con simulazione partita: Convalida
            -->

            <!-- Tasto di uscita: -->
            <input
              @click="isSimulazioneGuidata || simulazioniTerminate ? goBack() : abbandona()"
              :disabled="isLeftingSimulazione"
              type="button"
              style="background-color: #33A2F5"
              :value="`${ simulazioniTerminate ? 'Torna alla Home' : 'Esci'}`"
              class="btn simulazione-step-8 mr-5"
            >

            <!-- Tasto indietro: -->
            <input
              v-if="fintoStep >= 2"
              @click="vaiAPagina(fintoStep-1)"
              type="button"
              style="background-color: #33A2F5"
              value="Indietro"
              class="btn simulazione-step-8 mr-5"
            >

            <!-- Tasto bozza: -->
            <input
              type="button"
              style="background-color: #FFF4D4; color: #CFBA72; border: 1px solid #CFBA72;"
              value="Salva come bozza"
              title="Salva come bozza"
              class="btn mr-5"
              tabindex="3"
            >

            <!-- Tasto avanti: -->
            <input
              v-if="fintoStep <= 5"
              type="button"
              @click="vaiAPagina(fintoStep+1)"
              :disabled="eseguitaSimulazioneConGuida"
              style="background-color: #36BEA2"
              value="Avanti"
              class="btn btn-green simulazione-step-6"
              tabindex="2"
            >

            <!-- Tasto di convalida: -->
            <!-- v-if="fintoStep == 6 && status == 'started' && !isRichiestoF5" -->
            <input
              v-if="fintoStep == 6 && status == 'started'"
              type="button"
              @click="mostraFormConfermaInvioISMEA()"
              :disabled="eseguitaSimulazioneConGuida || simulazioniTerminate || checkboxesBloccantiAttive"
              style="background-color: #36BEA2"
              value="Convalida"
              class="btn btn-green simulazione-step-6"
              tabindex="2"
            >
          </v-row>

          <!-- Testo che avvisa che è richiesto per questa simulazione di premere F5 per completarla (no, non avvisarli) -->
          <!-- <v-row v-if="fintoStep == 6 && status == 'started' && isRichiestoF5" justify="end" class="mt-6 pr-11" style="color: red;">
            (Premi F5 per portare a termine questa simulazione)
          </v-row> -->
          <br><br><br>
        </v-card>
      </div>
    </div>

    <v-tour name="explanatoryTour" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            style="max-width: 600px"
            :highlight="tour.highlight"
          >
          </v-step>
        </transition>
      </template>
    </v-tour>

    <v-dialog v-model="isDatiCliccatoreDialogOpen" width="920">
      <v-card min-width=900 max-width=900>
        <v-card-title class="headline">
          <!-- <span class="ml-4">DATI CLICCATORE</span> -->
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isDatiCliccatoreDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div :style="`margin:0 10px 20px; color:${scdOrange}; font-weight:500;`">
            ATTENZIONE:<br>Questa finestra contiene i dati personali che possono essere richiesti durante le simulazioni. Devi quindi copiarli e incollarli in un blocco note per averli a portata di mano durante gli allenamenti.
          </div>
          <dati-cliccatore-component v-if="isDatiCliccatoreDialogOpen" :IdUtenteProp="computedIdUtente"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white;" depressed rounded class="mr-4 mb-3" @click="isDatiCliccatoreDialogOpen = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ricariche-component :toggleDialog="isDialogAcquistoRicaricheAperta" @chiudiDialog="chiudiDialogAcquistoRicariche($event)"></ricariche-component>

  <br><br>
  </div>
  
  <footer style="background-color: #D6A72F; height: 360px">
    <br>
    <div v-if="fintoStep != 1">
      <v-skeleton-loader boilerplate type="text" width="360" /><br>
      <v-skeleton-loader boilerplate type="text" width="720" /><br>
      <v-skeleton-loader boilerplate type="text"/><br>
      <v-skeleton-loader boilerplate type="text"/><br>
      <v-skeleton-loader boilerplate type="text"/><br>
      <v-skeleton-loader boilerplate type="text" width="360" /><br>
      <v-skeleton-loader boilerplate type="text" width="360" /><br>
      <v-skeleton-loader boilerplate type="text"/>
    </div>
    <div v-if="false">
      <strong style="font-size: 110%;">
        <div class="d-flex justify-center align-center" style="color:#002e5f; height: 100%;">
          La simulazione comincia alle ore <span class="px-1 simulazione-step-1">{{ orarioSimulazione }}.</span> Basati sull'orario che trovi sul sito <a class="ml-1" href="https://time.is/clock" target="_blank">time.is</a>
        </div>
        <div class="d-flex justify-center align-center" style="color:#002e5f; height: 100%;">
          ⚠️ In questa schermata (la n° {{fintoStep}}) clicca sul pulsante "AVANTI" solo dopo l'orario di inizio
        </div>
        <div class="d-flex justify-center align-center" style="color:#002e5f; height: 100%;">
          Per maggiori dettagli leggi il consiglio n° 2 che trovi nella pagina <a class="ml-1" href="/home#/gaming-consigli" target="_blank">Consigli</a>
        </div>
      </strong>
    </div>
  </footer>

  <v-snackbar
    v-model="validateTextVerificatoCorrettamente"
    :timeout="3000"
    top
    right
    color="success"
  >
    Campo verificato correttamente
  </v-snackbar>
  <v-snackbar
    v-model="erroriNelleRisposteSnackbar"
    :timeout="3000"
    top
    right
    color="error"
  >
    Tutti gli input richiesti non sono compilati correttamente.
  </v-snackbar>
  <v-snackbar
    v-model="campiNonValidatiSnackbar"
    :timeout="3000"
    top
    right
    color="error"
  >
    Campo non validato
  </v-snackbar>
  <v-snackbar
    v-model="simulazioneNonPartitaSnackbar"
    :timeout="3000"
    top
    right
    color="error"
  >
    Non è possibile validare la richiesta. Il bando non è più disponibile.
  </v-snackbar>
  <v-dialog v-model="dialogConfermaInvioIsmea" max-width="400px">
    <v-card>
      <v-card-title class="text-h6 d-flex justify-center text-center "><span>CONFERMA</span></v-card-title>
      <v-card-text>
        Attenzione, confermando l'operazione la domanda sarà convalidata e non sarà più possibile eliminarla.
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn style="background-color: #FDF0CE; color: #C6A450; border: 1px solid #C6A450;" text @click="()=>{continuaOppureInvia(true);}">Sì</v-btn>
        <v-btn outlined @click="dialogConfermaInvioIsmea = false">No</v-btn>
      </v-card-actions>
      <br>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import mixin from '../../mixins';
import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      pagina: 1, // Sono presenti 2 pagine e si passa dall'una all'altra
      fintoStep: 1,
      sempreTrue: true,

      alertType: null,
      message: null,
      
      valid: false,

      idCliccatore: this.computedIdUtente,

      isCliente: false,
      isProvaGratuita: false,
      isCliccatore: false,

      isLeftingSimulazione: false,

      status: null,
      pecIsmea: null,

      datiSimulazione: {
        id: null,
        dataOra: null,
        simulazione: [],
	      simulazioneConRisposteSenzaShuffle: [],
        // startIndex: 0,
        // endIndex: null,
        simulazioneGuidata: false
      },
      schermataAttuale: 0,
      maxSchermate: 0,

      simulazioniTerminate: false,

      bando: null,
	    
	    risposteCorrette: {
		    // uuid (stringa) : risposta corretta
		    // "3df85a92-a0f1-4ca3-9b4a-8b67e91cc467" : risposta corretta
	    },

      risposteUtente: {
        // Le informazioni inserite dall'utente
        // Verranno identificate attraverso un uuid generato nella funzione getDatiSimulazione()

        // uuid (stringa) : risposta dell'utente
        // "3df85a92-a0f1-4ca3-9b4a-8b67e91cc467" : risposta
      },

      risposteUtenteSplitted: {}, // Come il precedente ma permette di utilizzare dei campi 'splitted' ad esempio: unpastable_split_1_2_3

      // A causa della diversa formattazione della data, metto qua le risposte pronte ad essere confrontate con quelle del database
      risposteUtentePerIlConfronto: {},

      tastoContinuaVisibile: true,
      tastoIndietroVisibile: false,
      tastoInviaVisibile: false,

      // Inserisco il Csrf Token presente nei META
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

      // Tour guidato al primo accesso:
      eseguitaSimulazioneConGuida: false,

      tourSteps: [],
      tourOptions: {
          useKeyboardNavigation: false,
          labels: {
              buttonSkip: 'Salta guida',
              buttonPrevious: 'Precedente',
              buttonNext: 'Successivo',
              buttonStop: 'Fine'
          },
          highlight: true
      },
      tourCallbacks: {
        onPreviousStep: this.vaiAllaPaginaPrecedente,
        onNextStep: this.vaiAllaPaginaSuccessiva,
        onStop: this.utentePuoInteragire
      },
      currentStep: 2,
      tourInEsecuzione: false,

      ripetiGuida: false,

      isDatiCliccatoreDialogOpen: false,

      isDialogAcquistoRicaricheAperta: false,

      validateTextVerificatoCorrettamente: false,
      dialogConfermaInvioIsmea: false,
      erroriNelleRisposteSnackbar: false,
      campiNonValidatiSnackbar: false,
      simulazioneNonPartitaSnackbar: false,

      // isF5Premuto: false,
    };
  },

  mounted() {
    this.getDatiSimulazione();

    // Aggiungi un listener globale al montaggio del componente
    // window.addEventListener("keydown", this.onF5Press);
  },

  beforeDestroy() {
    // Rimuovi il listener globale prima che il componente venga distrutto
    // window.removeEventListener("keydown", this.onF5Press);
  },
	
	computed: {

    // isRichiestoF5(){
    //   if(this.isF5Premuto)
    //     return false;

    //   // Viene richiesto di premere F5 se sommando le cifre dell'orario di avvio della simulazione il risultato è divisibile per 5:
    //   let orario = moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('HHmmss');

    //   let sommaCifre = orario
    //     .split('') // Divide la stringa in un array di caratteri
    //     .reduce((acc, cifra) => acc + parseInt(cifra, 10), 0); // Somma i numeri convertiti

    //   // Controlla se la somma è divisibile per X (stabilito X=5)
    //   if (sommaCifre % 5 === 0) {
    //     return true;
    //   }
      
    //   return false;
    // },

    orarioSimulazione() {
			return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('HH:mm:ss');
		},
		annoMeseGiornoSimulazione() {
			return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('YYYY-MM-DD');
		},
		isSimulazioneGuidata() {
			return this.datiSimulazione.simulazioneGuidata;
		},
		checkboxesBloccantiAttive() {
			return this.datiSimulazione.simulazione.some(domandaObj => {
				return domandaObj.show === true
					&& (domandaObj.tipo == 'checkbox_bloccante' || domandaObj.tipo == 'summary')
					&& this.risposteUtente[domandaObj.id] !== this.risposteCorrette[domandaObj.id]
			});
		},
		summaryData() {
			return this.datiSimulazione.simulazione
				.filter(domandaObj => domandaObj.tipo != 'summary')
				.filter(domandaObj => domandaObj.schermata < this.schermataAttuale)
				.map(domandaObj => ({
					domanda: domandaObj.domanda,
					rispostaUtente: this.risposteUtente[domandaObj.id]
				}))
		}
	},
	
	watch: {
		// risposteUtente: {
		// 	handler: function(newVal, oldVal) {
		// 		console.log('risposteUtente', newVal)
		// 	},
		// 	deep: true
		// },
		// risposteUtentePerIlConfronto: {
		// 	handler: function(newVal, oldVal) {
		// 		console.log('risposteUtentePerIlConfronto', newVal)
		// 	},
		// 	deep: true
		// },
		// 'datiSimulazione.simulazione': {
		// 	handler: function(newVal, oldVal) {
		// 		console.log('datiSimulazione.simulazione', newVal)
		// 	},
		// 	deep: true
		// },
	},

  methods: {
    // Se si preme F5 torna al primo step
    // onF5Press(event) {
    //   if (event.key === "F5") {
    //     event.preventDefault();

    //     // this.isF5Premuto = true;
    //     this.vaiAPagina(1);
    //   }
    // },

    vaiAPagina(paginaDestinazione){
      let fintoStepAttuale = this.fintoStep;

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      // Se la simulazione non è ancora partita rimani sullo step in cui sei (in teoria sempre 1):
      // Se passo dalla 1 alla 2, chiedo la Simulazione con tutti i dati:
      if(paginaDestinazione > 1 && fintoStepAttuale == 1 && this.status != 'started'){
        // Allora chiamo la funzione per ottenere i dati e passo CB per andare ad altra schermata:

        this.getDatiSimulazione(()=>{
          if(this.status != 'started'){
            this.simulazioneNonPartitaSnackbar = true;
          } else {
            this.vaiAPagina(paginaDestinazione)
          }
        });
        
        return
      }

      this.fintoStep = paginaDestinazione;

      if(this.fintoStep == 2){
        if(fintoStepAttuale == 1)
          this.fintoStep = 3
        else if (fintoStepAttuale == 3)
          this.fintoStep = 1
      }
      // else if(this.fintoStep == 6)
      //   this.getDatiSimulazione();
    },

    ottieniRispostaUtenteConcatenata(domandaId){
      // Dal momento che possono esistere parti statiche che l'utente non deve inserire ma che fanno parte della risposta,
      // utilizzo i ref per ottenere la risposta completa concatenata

      let riferimentiRispostaUtente = this.$refs[domandaId]
      
      // Concatenazione dei valori di span e input
      let rispostaUtenteConcatenata = Array.from(riferimentiRispostaUtente)
        .map(el => {
          if (el.tagName === "INPUT") {
            if (el.type === "checkbox" || el.type === "radio") {
              return el.checked ? el.value : ""; // Prendi il valore solo se selezionato
            }
            return el.value; // Altri input (es. text)
          } else if (el.tagName === "SELECT") {
            return el.value; // Prendi il valore del select
          } else {
            return el.textContent; // Altrimenti usa il testo
          }
        })
        .join("");

      return rispostaUtenteConcatenata;
    },

    ottieniRispostaCorrettaSenzaDivisoriStatici(domandaId){
      // Elimino eventuali divisori { e } che indicano campi statici non inseribili dall'utente.
      // Es: {AA}BB{CC} diventa AABBCC:
      let rispostaCorretta = this.risposteCorrette[domandaId];

      if (typeof rispostaCorretta === "string")
        return rispostaCorretta.replace(/[{}]/g, "");
      else 
        return rispostaCorretta
    },

    // Questa funzione restituisce separatamente le parti della stringa che sono racchiuse tra parentesi graffe (che dovranno essere considerate
    // come parti statiche, non inseribili dall'utente) e fuori dalle graffe (parti che l'utente deve inserire)
    ottieniPartiStringa(stringa) {
      const regex = /{(.*?)}|([^{}]+)/g; // Match contenuto tra graffe o fuori
      const parti = [];
      let match;

      while ((match = regex.exec(stringa)) !== null) {
        if (match[1]) {
          // Contenuto tra graffe
          parti.push({ traGraffeQuindiStatico: true, contenuto: match[1] });
        } else if (match[2]) {
          // Contenuto fuori dalle graffe
          parti.push({ traGraffeQuindiStatico: false, contenuto: match[2] });
        }
      }

      return parti;
    },

    verificaValidateText(idxDomanda){
      let domandaObj = this.datiSimulazione.simulazione[idxDomanda];

      // let rispostaUtente = this.risposteUtente[domandaObj.id];
      // La risposta utente, dato che possono esistere campi statici, la prendo concatenando gli elementi del DOM con ref = domanda.id
      
      let rispostaUtente = this.ottieniRispostaUtenteConcatenata(domandaObj.id);
      let rispostaCorretta = this.ottieniRispostaCorrettaSenzaDivisoriStatici(domandaObj.id/*domandaObj.risposte[0]*/);

      if(rispostaUtente === rispostaCorretta){
        // Corretto:
          // Mostra messaggio in verde in alto a dx (e nascondo colore rosso del campo)
          // Imposta la risposta come validata:
        domandaObj.rispostaValidata = true;
        
        domandaObj.rispostaNonCorretta = false;
        this.validateTextVerificatoCorrettamente = true;
      } else {
        // Colora campo di rosso
        domandaObj.rispostaNonCorretta = true;
      }

    },

    mostraFormConfermaInvioISMEA(){
      this.dialogConfermaInvioIsmea = true;
    },

    // precompilaCampiSplitted(){
    //   // Se il tipo della domanda è ad esempio 'unpastable_split_...' allora precompilo i campi non richiesti dallo split

    //   for (const key in this.datiSimulazione.simulazione) {
		// 	  let UUIDSimulazione = this.datiSimulazione.simulazione[key].id;

    //     if(this.datiSimulazione.simulazione[key].tipo.startsWith('unpastable_split_')){
    //       // La risposta corretta avrà la forma: INN24_01628_PC
    //       // Quindi separo le 3 parti: INN24, 01628, PC e le precompilo se una parte non è richiesta dalla domanda:
    //       let rispostaCorrettaCompleta = this.datiSimulazione.simulazioneConRisposteSenzaShuffle[key].risposte[0];
    //       let primaParte = rispostaCorrettaCompleta.split("_")[0];
    //       let secondaParte = rispostaCorrettaCompleta.split("_")[1];
    //       let terzaParte = rispostaCorrettaCompleta.split("_")[2];

    //       // Inizializzo l'array splitted:
    //       this.risposteUtenteSplitted[UUIDSimulazione] = {
    //         'split_1': null,
    //         'split_2': null,
    //         'split_3': null,
    //       }
        
    //       if(!this.datiSimulazione.simulazione[key].tipo.includes('_1')){ // Se non include il primo, allora precompilo il campo (e poi verrà messo readonly)
    //         this.risposteUtenteSplitted[UUIDSimulazione].split_1 = primaParte;
    //       }
    //       if(!this.datiSimulazione.simulazione[key].tipo.includes('_2')){
    //         this.risposteUtenteSplitted[UUIDSimulazione].split_2 = secondaParte;
    //       }
    //       if(!this.datiSimulazione.simulazione[key].tipo.includes('_3')){
    //         this.risposteUtenteSplitted[UUIDSimulazione].split_3 = terzaParte;
    //       }
    //     }
		//   }
    // },

    // Aggiunta per il tipo 'monochar'
    // handleMonochar(index, char, domandaObj) {
		//   domandaObj.risposteMonochar[index] = char || '';
		//   this.risposteUtente[domandaObj.id] = '';
		//   for (const index in domandaObj.risposteMonochar) {
		// 	  if (domandaObj.risposteMonochar[index] !== null) {
		// 		  this.risposteUtente[domandaObj.id] += domandaObj.risposteMonochar[index];
		// 	  }
		//   }
	  // },
    // =================================

    getDatiSimulazione(cbSuccess = null) {
      axios
      .get('/ottieniSimulazione')
      .then(response => {
	      this.datiSimulazione.id = response.data.simulazione.id;
	      this.datiSimulazione.dataOra = response.data.simulazione.dataOra;
	      this.datiSimulazione.simulazioneGuidata = response.data.simulazione.simulazioneGuidata;
				
				// le domande le ho ordinate per schermata usando un metodo di Laravel
	      this.datiSimulazione.simulazioneConRisposteSenzaShuffle = response.data.simulazione.simulazioneConRisposteSenzaShuffle // copia esatta del database
	      this.datiSimulazione.simulazione = response.data.simulazione.simulazione;
	      
	      this.maxSchermate = response.data.simulazione.maxSchermate;
	      this.simulazioniTerminate = response.data.simulazione.simulazioniTerminate;

        // Aggiunta per monochar
        // ===> NOTA: Non più necessaria perché logica spostata in setVariabiliAccessione
        // this.datiSimulazione.simulazione.forEach(domanda => {
        //   domanda.uuid = this.$uuid.v4(); // assegno un id univoco ad ogni domanda
        //   // nell'oggetto delle risposte da inviare per il controllo, per ogni domanda creo una chiave univoca con lo stesso nome dell'id creato nella riga precedente
				// 	if (domanda.tipo == 'checkbox') this.risposteUtente[domanda.uuid] = false
				// 	else if (domanda.tipo == 'monochar') {
				// 		this.risposteUtente[domanda.uuid] = '';
				// 		domanda.risposteMonochar = {};
				// 		for (let i = 0; i < domanda.risposte[0].length; i++) {
				// 			domanda.risposteMonochar[i] = null;
				// 		}
				// 		// console.log(domanda.risposteMonochar)
				// 	}
				// 	else this.risposteUtente[domanda.uuid] = null;
        //   domanda.rispostaNonCorretta = false;
        //   domanda.show = false;
        // });
        // ========================

	      this.status = response.data.status;
	      this.bando = response.data.bando;

        if(response.data.pec_ismea)
          this.pecIsmea = response.data.pec_ismea;
        else
          this.pecIsmea = "esempio@pec.it";

        // Svuoto i due oggetti di nuovo (getDatiSimulazione(..) potrebbe essere chiamata più volte):
        this.risposteUtente = {};
        this.risposteUtentePerIlConfronto = {};
	      
	      this.setVariabiliAccessorie();
				this.setRisposteCorrette();

        // Se il tipo della domanda è ad esempio 'unpastable_split_...' allora precompilo i campi non richiesti dallo split
        // this.precompilaCampiSplitted();
				
	      this.schermataAttuale = 0;
	      if (this.status == 'started') {
		      this.setDomandeESchermataDaMostrare('avanti');
	      }
	      
	      this.startSimulazioneTour();
	      
	      if (this.simulazioniTerminate && !this.datiSimulazione.simulazioneGuidata) {
		      this.mostraBannerSimulazioniTerminate();
	      }

        if(cbSuccess != null)
          cbSuccess()
      })
    },
	  setVariabiliAccessorie() {
      // NOTA: qui viene inizializzato anche risposteUtentePerIlConfronto.. che avrà lo stesso ordine delle domande

		  this.datiSimulazione.simulazione.forEach(domanda => {
			  this.$set(domanda, 'id', this.$uuid.v4()); // assegno un id univoco ad ogni domanda
			  
			  // nell'oggetto delle risposte da inviare per il controllo, per ogni domanda creo una chiave univoca con lo stesso nome dell'id creato nella riga precedente
			  if (domanda.tipo == 'checkbox'
				  || domanda.tipo == 'checkbox_bloccante'
				  || domanda.tipo == 'summary'
			  ) {
				  this.$set(this.risposteUtente, domanda.id, false); // reactive
				  this.$set(this.risposteUtentePerIlConfronto, domanda.id, false); // reactive
			  }
			  else if (domanda.tipo == 'checkbox_reverse') {
				  this.$set(this.risposteUtente, domanda.id, true); // parte già spuntata
				  this.$set(this.risposteUtentePerIlConfronto, domanda.id, true); // parte già spuntata
			  }
        // ===== Aggiunta per monochar ======
        else if (domanda.tipo == 'monochar') {
          // this.risposteUtente[domanda.id] = '';
          this.$set(this.risposteUtente, domanda.id, null); // reactive
				  this.$set(this.risposteUtentePerIlConfronto, domanda.id, null); // reactive
          domanda.risposteMonochar = {};
          for (let i = 0; i < domanda.risposte[0].length; i++) {
            domanda.risposteMonochar[i] = null;
          }
        }
        // ===================================
			  else {
				  this.$set(this.risposteUtente, domanda.id, null); // reactive
				  this.$set(this.risposteUtentePerIlConfronto, domanda.id, null); // reactive
			  }

        if(domanda.tipo == 'validate_text'){
          this.$set(domanda, 'rispostaValidata', false);
        }
			  
			  this.$set(domanda, 'rispostaNonCorretta', false); // reactive
			  this.$set(domanda, 'show', false); // reactive
		  });
	  },
	  setRisposteCorrette() {
		  for (const key in this.datiSimulazione.simulazione) {
			  let UUIDSimulazione = this.datiSimulazione.simulazione[key].id;
			  this.$set(this.risposteCorrette, UUIDSimulazione, this.datiSimulazione.simulazioneConRisposteSenzaShuffle[key].risposte[0]); // reactive
		  }
	  },
    setDomandeESchermataDaMostrare(direzione) {
      this.setSchermataAttuale(direzione);

			// se per qualche motivo genero un loop con while lo fermo se arriva a 50 cicli
      let maxCicliEmergenza = 0;
			
      let domandeTrovatePerSchermataAttuale = false;
      while (!domandeTrovatePerSchermataAttuale) {
        for (let i = 0; i < this.datiSimulazione.simulazione.length; i++) {
          if (this.datiSimulazione.simulazione[i].schermata == this.schermataAttuale) {
            this.datiSimulazione.simulazione[i].show = true;
            domandeTrovatePerSchermataAttuale = true;
          } else if (this.datiSimulazione.simulazione[i].schermata != this.schermataAttuale) {
            this.datiSimulazione.simulazione[i].show = false;
          }
        }

        if (!domandeTrovatePerSchermataAttuale) {
          this.setSchermataAttuale(direzione);
        }

        // visibilità pulsanti
        if (this.schermataAttuale > 1) {
          this.tastoIndietroVisibile = true;
        } else if (this.schermataAttuale == 1) {
          this.tastoIndietroVisibile = false;
        }

        if (this.schermataAttuale == this.maxSchermate) {
          this.tastoContinuaVisibile = false;
          this.tastoInviaVisibile = true;
        } else if (this.schermataAttuale < this.maxSchermate) { // nel back-end ho impostato massimo 4 schermate
          this.tastoContinuaVisibile = true;
          this.tastoInviaVisibile = false;
        }

        maxCicliEmergenza++;
        if (maxCicliEmergenza == 50) {
          break;
        }

      }
    },
    setSchermataAttuale(direzione) {
      if (direzione == 'avanti' && this.schermataAttuale < this.maxSchermate) {
        this.schermataAttuale++;
      } else if (direzione == 'indietro' && this.schermataAttuale > 1) {
        this.schermataAttuale--;
      }
    },
    tornaAllaPrimaSchermata() {
      this.schermataAttuale = 0;
      this.setDomandeESchermataDaMostrare('avanti');
    },
    goBack: function(){
      // Torna semplicemente indietro: disponibile quando sto visualizzando la guida
      window.location.href = "/home#/";
    },
    abbandona: function() {
      // Avviso il server di segnare la simulazione come abbandonata, e poi torno indietro
      this.isLeftingSimulazione = true;

      axios
        .get(`/simulazioni/${this.datiSimulazione.id}/${this.bando.id}/${this.annoMeseGiornoSimulazione}/abbandona`)
        .then(response => {
          window.location.href = "/home#/";
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isLeftingSimulazione = false;
        });
    },
    continuaOppureInvia: function(inviaForm, direzione) {
      if (this.tourInEsecuzione) {
        return;
      }

      if (this.simulazioniTerminate) {
        this.setDomandeESchermataDaMostrare(direzione);
        return;
      }

      // creo un oggetto con le risposte corrette
      // uuid (stringa) : risposta (number)
      for (const key in this.datiSimulazione.simulazione) {
        let UUIDSimulazione = this.datiSimulazione.simulazione[key].id;
	      
        if (this.datiSimulazione.simulazione[key].tipo == 'data'
	        && moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD", true).isValid()
        ) {
          this.risposteUtentePerIlConfronto[UUIDSimulazione] = moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD").format('DD/MM/YYYY');
        } 
        else if(this.datiSimulazione.simulazione[key].tipo == 'checkbox'){
          this.risposteUtentePerIlConfronto[UUIDSimulazione] = this.risposteUtente[UUIDSimulazione]; // Un booleano
          // console.log("è una checkbox con:")
          // console.log(this.risposteUtente[UUIDSimulazione])
          // return
          // if(this.risposteUtente[UUIDSimulazione])
          //   this.risposteUtentePerIlConfronto[UUIDSimulazione] = true;
          // else
          //   this.risposteUtentePerIlConfronto[UUIDSimulazione] = false;
        }
        else if(this.datiSimulazione.simulazione[key].tipo == 'reverse'){
          // Se di tipo 'reverse', allora l'utente deve aver inserito la stringa scritta al contrario
          this.risposteUtentePerIlConfronto[UUIDSimulazione] = this.risposteUtente[UUIDSimulazione].split("").reverse().join(""); // Un booleano
        }
        // else if(this.datiSimulazione.simulazione[key].tipo.startsWith('unpastable_split_')){ // Se la risposta è di tipo split su più campi la unisco prima di effettuare i controlli
        //   this.risposteUtentePerIlConfronto[UUIDSimulazione] = this.risposteUtenteSplitted[UUIDSimulazione].split_1 + "_" + this.risposteUtenteSplitted[UUIDSimulazione].split_2 + "_" + this.risposteUtenteSplitted[UUIDSimulazione].split_3
        // }
        else {
          // this.risposteUtentePerIlConfronto[UUIDSimulazione] = this.risposteUtente[UUIDSimulazione];
          // Nota: non vengono più utilizzati i v-model con le risposte che è possibile concatenare
          this.risposteUtentePerIlConfronto[UUIDSimulazione] = this.ottieniRispostaUtenteConcatenata(UUIDSimulazione);
        }

        /*else if(this.datiSimulazione.simulazione[key].tipo == 'INN24_select_PC'){
          // Se il tipo è "INN24_select_PC" allora concateno la risposta con il prefisso ed il suffisso prima di proseguire:
          this.risposteUtentePerIlConfronto[UUIDSimulazione] = "INN24_" + this.risposteUtente[UUIDSimulazione] + "_PC";
        }*/
      }

      // confronto le risposte dell'utente e le risposte corrette
	    // let indexSimulazione = 0;
	    // for (const uuid in this.risposteUtentePerIlConfronto) {
      //   const rispostaUtente = this.risposteUtentePerIlConfronto[uuid];
			//
      //   // se la risposta dell'utente e quella corretta non combaciano e la domanda è renderizzata, c'è un errore
      //   if (rispostaUtente != risposteCorrette[uuid] && this.datiSimulazione.simulazione[indexSimulazione].show == true) {
      //     errorFound = true;
      //     this.datiSimulazione.simulazione[indexSimulazione].rispostaNonCorretta = true;
      //     this.$forceUpdate();
			//
      //   } else {
      //     this.datiSimulazione.simulazione[indexSimulazione].rispostaNonCorretta = false;
      //     this.$forceUpdate();
      //   }
      //   indexSimulazione++;
      // }
	    
	    // if (!inviaForm && !errorFound) {
		  //   // this.toggleDomande();
		  //   this.setDomandeESchermataDaMostrare(direzione);
		  //   return;
	    // }
	    
	    if (!inviaForm) {
		    this.setDomandeESchermataDaMostrare(direzione);
		    return;
	    }
			
			let errorFound = false;
	    let schermataInCuiHoTrovatoIlPrimoErrore = null;
			
			if (inviaForm) {
        // Se c'è anche solo un campo 'validate_text' non Convalidato (ma compilato), non permette di proseguire (mostrando snackbar di errore ma non il punto da correggere):
        for (const key in this.datiSimulazione.simulazione) {
          let domandaObj = this.datiSimulazione.simulazione[key];
          
          if(domandaObj.tipo == 'validate_text' && !domandaObj.rispostaValidata && (this.risposteUtente[domandaObj.id] && this.risposteUtente[domandaObj.id] != ''/*this.risposteUtentePerIlConfronto[domandaObj.id] && this.risposteUtentePerIlConfronto[domandaObj.id] != ''*/)){
            this.campiNonValidatiSnackbar = true;
            return;
          }
        }
        // ============================================

				for (const key in this.datiSimulazione.simulazione) {
					let domandaObj = this.datiSimulazione.simulazione[key];

          let rispostaCorretta = this.ottieniRispostaCorrettaSenzaDivisoriStatici(domandaObj.id);
					if (/*this.risposteCorrette[domandaObj.id]*/rispostaCorretta != this.risposteUtentePerIlConfronto[domandaObj.id]) {
						errorFound = true;
						domandaObj.rispostaNonCorretta = true;
						
						if (schermataInCuiHoTrovatoIlPrimoErrore === null) {
							schermataInCuiHoTrovatoIlPrimoErrore = domandaObj.schermata;
						}
					}
					else {
						domandaObj.rispostaNonCorretta = false;
					}
				}
			}

      // Nota: le risposte utente sono concatenate con eventuali parti statiche, quindi possono essere inviate al backend
			
			if (errorFound) {
				this.tornaAllaPrimaSchermata();

        // Mostro la snackbar con l'errore:
        this.erroriNelleRisposteSnackbar = true;
				
				// dopo essere ritornato alla prima schermata con il metodo this.tornaAllaPrimaSchermata(),
				// se il primo errore si trova in una schermata successiva alla prima, vado a vanti fino a quella schermata
				if (schermataInCuiHoTrovatoIlPrimoErrore > 1) {
					while (schermataInCuiHoTrovatoIlPrimoErrore != this.schermataAttuale) {
						this.setDomandeESchermataDaMostrare('avanti');
					}
				}
				
				// ripristino tutte le checkbox come erano in partenza (è il comportamento della pagina ufficiale inail)
				this.datiSimulazione.simulazione
					.filter(domanda => domanda.schermata >= schermataInCuiHoTrovatoIlPrimoErrore)
					.forEach(domanda => {
						if (domanda.tipo == 'checkbox'
							|| domanda.tipo == 'checkbox_bloccante'
							|| domanda.tipo == 'summary'
						) {
							this.risposteUtente[domanda.id] = false;
						}
						else if (domanda.tipo == 'checkbox_reverse') {
							this.risposteUtente[domanda.id] = true;
						}
					});
				
				return;
			}

      // console.log("this.risposteUtentePerIlConfronto")
      // console.log(JSON.stringify(this.risposteUtentePerIlConfronto))

      if (!errorFound) {
        // Se sono in modalità GUIDA, non proseguire a mostrare il risultato!
        if (this.isSimulazioneGuidata && inviaForm){
          this.eseguitaSimulazioneConGuida = true;
          this.$tours['explanatoryTour'].stop();
          return;
          // e.preventDefault();
          // return false;
        }
        // return true;

        let formData = new FormData();
        formData.append('risposte', JSON.stringify(this.risposteUtentePerIlConfronto));
        formData.append('simulazione_id', this.datiSimulazione.id);
        formData.append('bando_id', this.bando.id);
        formData.append('anno_mese_giorno_simulazione', this.annoMeseGiornoSimulazione);
        axios.post('/risultato',
          formData,       
          {
            headers: {
                'Content-Type': 'application/json'
            },
          }
        )
        .then(response => {
          let risultatoSimulazione = {
              bandoId: this.bando.id,
              provaGratuita: response.data.provaGratuita,
              countAltriUtenti: response.data.countAltriUtenti,
              minimoAltriUtenti: response.data.minimoAltriUtenti,
              tempoImpiegato: response.data.tempoImpiegato,
              colore: response.data.colore,
              hasError: response.data.hasError,
              message: response.data.message,
            } 

          localStorage.setItem('risultatoSimulazione', JSON.stringify(risultatoSimulazione));
	        
	        this.$router.push({
		        name: `risultato-${this.bando.route}`,
		        params: risultatoSimulazione
	        });
        })
      }
      // else e.preventDefault();
        
    },
    // toggleDomande(saltaCodice) {
    //   if (saltaCodice) {
    //     return;
    //   }

    //   for (const key in this.datiSimulazione.simulazione) {
    //     this.datiSimulazione.simulazione[key].show = !this.datiSimulazione.simulazione[key].show;
    //   }

    //   this.tastoContinuaVisibile = !this.tastoContinuaVisibile;
    //   this.tastoIndietroVisibile = !this.tastoIndietroVisibile;
    //   this.tastoInviaVisibile = !this.tastoInviaVisibile;
    // },
    getTimeByDatetime: function(datetime) {
      return datetime.split(" ")[1];
    },
    openGuide() {
      this.ripetiGuida = true;
      if (this.tastoInviaVisibile) { // se il tasto invia è visibile vuol dire che sono nella seconda schermata e lo riporto nella prima
        this.toggleDomande();
      }
      this.startSimulazioneTour();
      // this.$tours['explanatoryTour'].start();
    },
    startSimulazioneTour() {
      // Se il parametro "Guida" è nell'URL allora avvio la guida
      if(this.isSimulazioneGuidata || this.ripetiGuida){
        this.tourInEsecuzione = true;
        
        if(this.status == 'not_started'){
          this.tourSteps = [
            {
              target: '.simulazione-step-1',
              content: `Eccoci alla tua prima Simulazione!<br>Appena si avvicina l'orario indicato, aggiorna la pagina<br>(per farlo velocemente premi 'F5' su Windows o 'Mela+R' su MAC)`
            }
          ];
        } else { // Se la simulazione è partita e la Guida è richiesta mostro questo:
          this.tourSteps = [
              {
                target: '.simulazione-step-2',
                content: `La simulazione è divisa in più pagine, ogni pagina ti chiederà di compilare dei campi`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-3',
                content: `Questa è la prima serie di campi,<br>presta molta attenzione a cosa c'è scritto.`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-4',
                content: `Questo bottone ti permette di visualizzare la seconda pagina, 
                ma solamente se avrai compilato correttamente i campi in questa pagina.`,
                params: {
                  placement: 'left-end'
                }
              },
              {
                target: '.simulazione-step-5',
                content: `Ora siamo nella seconda pagina e questa è la seconda serie di campi`,
                params: {
                  placement: 'top'
                },
                // before: promise => new Promise((resolve, reject) => {
                //   // Time-consuming UI/async operation here
                //   let response = this.continuaOppureInvia(false, true);
                //   if (response == 'pagina successiva') {
                //     resolve(response);
                //   }
                // })
                // .then(() => {
                //   this.toggleDomande();
                //   console.log('then');
                // })
              },
              {
                target: '.simulazione-step-6',
                content: `Questo bottone ti permette di eseguire la simulazione, 
                sempre dopo aver correttamente compilato i campi`,
                params: {
                  placement: 'top-end'
                }
              },
              {
                target: '.simulazione-step-7',
                content: `Questo bottone ti permette di tornare alla pagina precedente`,
                params: {
                  placement: 'top-start'
                }
              },
              {
                target: '.simulazione-step-8',
                content: `Se vuoi abbandonare la simulazione usa questo bottone.<br><br>
                Ricorda che il giorno del vero Click Day non potrai tornare indietro se l’invio della domanda è difficile, avrai una sola chance. Per cui ti consigliamo di non abbandonare mai le simulazioni ma di allenarti a superarle tutte!<br><br>
                Ora tocca a te, cliccando su Fine tornerai alla prima pagina e potrai svolgere questa simulazione di prova!`,
                params: {
                  placement: 'left-start'
                }
              },
            ]     
        }

        setTimeout(() => {
          this.$tours['explanatoryTour'].start();
        }, 10);
      }
    },
    vaiAllaPaginaPrecedente() {
      this.currentStep--;
      if (this.currentStep == 4) {
        this.setDomandeESchermataDaMostrare('indietro');
      }
    },
    vaiAllaPaginaSuccessiva() {
      this.currentStep++;
      if (this.currentStep == 5) {
        this.setDomandeESchermataDaMostrare('avanti');
      }
    },
    utentePuoInteragire() {
      this.tourInEsecuzione = false;
      this.tornaAllaPrimaSchermata();
    },

    mostraBannerSimulazioniTerminate() {
      if (window.__NOME_PACCHETTO__ == 'PROVAGRATUITA') {
        this.isProvaGratuita = true;
      } else if (window.__NOME_PACCHETTO__ != 'PROVAGRATUITA' && window.__RUOLO__ == 'Admin') {
        this.isCliente = true;
      } else if (window.__NOME_PACCHETTO__ != 'PROVAGRATUITA' && window.__RUOLO__ != 'Admin') {
        this.isCliccatore = true;
      }
    },
    apriPaginaPacchetti() {
      window.open('https://simulatoreclickday.it/acquista/');
    },
    apriDialogAcquistoRicariche() {
      this.isDialogAcquistoRicaricheAperta = true;
    },
    chiudiDialogAcquistoRicariche() {
      this.isDialogAcquistoRicaricheAperta = false;
    },
    showDatiCliccatore(idCliccatore) {
      this.idCliccatoreToShowDati = idCliccatore;
      this.isDatiCliccatoreDialogOpen = true;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');

	* {
		font-family: 'Open Sans', sans-serif !important;
	}

	::v-deep {
		.v-input--checkbox label {
			color: black !important;
			font-size: 14px !important;
			font-family: 'Open Sans', sans-serif !important;
		}
	}

  .body {
    min-width: 489.1px;
    max-width: 1366px;
    width: auto;
    margin-right: auto;
    margin-left: auto;
    font-size: 14.4333px;
		background-color: white;
  }
  footer {
    //position: absolute;
    //bottom: 0;
    //left: 0;
    width: 100%;
    background-color: #002e5f;
    padding: 20px 60px 20px;
    color: #fff;
    font-size: .9em;
  }
  #logo-inail {
    margin-left: 60px;
    margin-bottom: 40px;
    display: block;
  }
  #logo-inail img {
    width: 240px;
  }
  h1 {
    display: none
  }
  h2 {
    margin-top: 0;
  }
  h3 {
    margin: 0;
    margin-bottom: 30px;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 16.5px;
  }
  h4 {
    font-size: 1.25em;
    margin-top: 10px;
    margin-bottom: 25px;
    font-weight: 500;
    line-height: 1.1;
  }
  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }
  p {
    margin-bottom: 10px;
  }
  header {
    padding-top: 48px;
    // border-bottom: 20px solid #002e5f;
  }
  .main {
    // border-top: 20px solid #1E6665;
    padding-top: 5px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 60px;
  }
  .main h2 {
    color: #D6A72F;
    margin-bottom: 30px;
    font-family: 'Open Sans semibold', sans-serif;
    font-size: 23.8333px;
    font-weight: 500;
  }
  .mr-15 {
      margin-right: 15px;
  }
  .form-gray {
    background-color: #EFEFEF;
    padding: 35px 30px;
  }
  .form-elem {

    margin-bottom: 20px;
  }
  .form-elem .msg {
    position: relative;
    top: 5px;
    display: none;
  }
  .form-elem input:not([type="checkbox"]):not([type="radio"]),
  //.form-elem label,
  .form-elem select {
    width: 100%;
    border: 1px solid #afafaf;
    background-color: #fff;
    height: 34px;
    box-sizing: border-box;
    padding: 6px 12px;
  }
  .form-elem input:focus,
  .form-elem select:focus {
    outline: 0;
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
  }
  .form-elem label {
    margin-bottom: 5px;
    display: inline-block;
	  color: black;
  }
  .form-elem.errore .msg {
    display: block;
  }
  .form-elem.errore input:focus,
  .form-elem.errore select:focus {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;
  }
  .form-elem.errore input,
  .form-elem.errore select {
    border-color: #c9291b !important;
    /* border-color: #C9291B; */
  }
  .form-elem.errore label,
  .testo-errore {
    color: #c9291b ;
    /* color: #C9291B; */
  }
  .form-elem.date-elem label {
    display: block;
  }
  .form-elem.date-elem input{
      width: 200px;
  }
  .btn {
    background-color: #002e5f;
    color: #fff;
    text-transform: uppercase;
    border-radius: 0;
    border: 0;
    min-width: 160px;
    font-weight: 400;
    padding: 6px 12px;
    line-height: 1.92857em;
    cursor: pointer;
    &.abbandona {
      background-color: #bc2025;
    }
    &.dati-personali {
      background-color: #e6901c;
    }
	  &.btn-green {
		  background-color: #0e821a;
	  }
  }
  //.btn-row {
    //height: 40px;
    //margin-top: 40px;
  //}
  .btn[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    box-shadow: none;
    background: #d2d2d2;
    border-color: #d2d2d2;
    color: #002e5f;
    opacity: 1 !important;
  }

  .btn:focus,
  input[type=checkbox]:focus, .feedback:focus {
    outline: thin dotted;
    outline-offset: -2px;
  }
  input[type=checkbox] {
    margin: 0;
    margin-right: 5px;
    top: 3px;
    position: relative;
  }
  .pull-right {
    float: right;
  }
  .xs-12 {
    width: 100%;
  }

  ::v-deep ._radio_group label,
  ::v-deep ._checkbox label {
    animation: none !important;
  }

  /*SM*/
  @media (min-width: 768px) {}
  /*MD*/
  @media (min-width: 992px) {
    //.md-3 {
    //    width: 25%;
    //}
    .md-6 {
       width: 50%;
      //width: 100%;
    }
  }

  /*LG*/
  @media (min-width: 1200px) {}
  .loader-overlay {
    position: fixed;
    background-color: #002E5F;
    background-color: rgba(0, 46, 95, 0.2);
    width:100%;
    height:100%;
    top:0;
    left: 0;
    opacity: 1;
    z-index: 500000;
  }
  .loader-overlay span{
    position: fixed; /* or absolute */
    top: 50%;
    left: 50%;
    border: 10px solid #106CDB; /* Light grey */
    border-top: 10px solid #002e5f; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .data-summary strong {
      width: 200px;
      display: inline-block;
  }

  .avviso-finale-prova {
    position: absolute;
    bottom: 200px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .page-overlay {
    position: absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.50);
  }

  .tour-2-3 {
    width: 100%;
  }
  @media (min-width: 992px) {
    .tour-2-3 {
      width: 50%;;
    }
  }

  .ok-button-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
  }
  .ok-button {
    color: #002e5f;
    font-size: 20px;
    text-decoration: none;
    padding: 5px 10px;
    background-color: white;
    border-radius: 3px;
  }

  input[type="button"] {
    font-weight: bold;
  }
</style>